// @ts-nocheck
import createBookButtonWidget from './createBookButtonWidget';
export default ({ editorAPI }) =>
  createBookButtonWidget({
    editorAPI,
  });
